import React from 'react';

/**
 * Componente LoadingSpinner reutilizable
 * Se muestra mientras se carga contenido lazy loaded
 */
const LoadingSpinner = ({ message = 'Cargando...' }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100svh - 72px)',
      gap: '1rem',
      fontSize: '1.1rem',
      color: '#16A797',
      fontWeight: '600'
    }}>
      <div aria-hidden="true" style={{
        animation: 'spin 1s linear infinite',
        fontSize: '2rem'
      }}>
        ⟳
      </div>
      <p>{message}</p>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
